import { Table, MenuItem, Order, OrderItem } from '../types';
import { v4 as uuidv4 } from 'uuid';

export function generateMockData() {
  const menuItems: MenuItem[] = [
    // Starters
    { id: uuidv4(), name: 'Oysters (6)', translationKey: 'oysters', category: 'Starters', price: 18, available: true, description: 'Fresh east coast oysters with mignonette', descriptionKey: 'oystersDesc' },
    { id: uuidv4(), name: 'Tuna Tartare', translationKey: 'tunaTartare', category: 'Starters', price: 22, available: true, description: 'Sesame crusted tuna with avocado', descriptionKey: 'tunaTartareDesc' },
    { id: uuidv4(), name: 'Burrata', translationKey: 'burrata', category: 'Starters', price: 16, available: true, description: 'Creamy burrata with heirloom tomatoes', descriptionKey: 'burrataDesc' },
    { id: uuidv4(), name: 'Beef Carpaccio', translationKey: 'beefCarpaccio', category: 'Starters', price: 19, available: true, description: 'Thinly sliced beef with arugula and parmesan', descriptionKey: 'beefCarpaccioDesc' },
    { id: uuidv4(), name: 'Shrimp Cocktail', translationKey: 'shrimpCocktail', category: 'Starters', price: 17, available: true, description: 'Jumbo shrimp with cocktail sauce', descriptionKey: 'shrimpCocktailDesc' },

    // Mains
    { id: uuidv4(), name: 'Grilled Salmon', translationKey: 'grilledSalmon', category: 'Mains', price: 32, available: true, description: 'Atlantic salmon with seasonal vegetables', descriptionKey: 'grilledSalmonDesc' },
    { id: uuidv4(), name: 'Ribeye Steak', translationKey: 'ribeyeSteak', category: 'Mains', price: 48, available: true, description: '12oz ribeye with garlic butter', descriptionKey: 'ribeyeSteakDesc' },
    { id: uuidv4(), name: 'Lobster Risotto', translationKey: 'lobsterRisotto', category: 'Mains', price: 42, available: true, description: 'Creamy risotto with fresh lobster', descriptionKey: 'lobsterRisottoDesc' },
    { id: uuidv4(), name: 'Roasted Chicken', translationKey: 'roastedChicken', category: 'Mains', price: 28, available: true, description: 'Half chicken with herbs and lemon', descriptionKey: 'roastedChickenDesc' },
    { id: uuidv4(), name: 'Pasta Carbonara', translationKey: 'pastaCarbonara', category: 'Mains', price: 24, available: true, description: 'Classic carbonara with pancetta', descriptionKey: 'pastaCarbonaraDesc' },
    { id: uuidv4(), name: 'Sea Bass', translationKey: 'seaBass', category: 'Mains', price: 36, available: true, description: 'Pan-seared bass with citrus sauce', descriptionKey: 'seaBassDesc' },

    // Desserts
    { id: uuidv4(), name: 'Chocolate Soufflé', translationKey: 'chocolateSouffle', category: 'Desserts', price: 12, available: true, description: 'Warm chocolate soufflé with vanilla ice cream', descriptionKey: 'chocolateSouffleDesc' },
    { id: uuidv4(), name: 'Crème Brûlée', translationKey: 'cremeBrulee', category: 'Desserts', price: 10, available: true, description: 'Classic vanilla custard with caramelized sugar', descriptionKey: 'cremeBruleeDesc' },
    { id: uuidv4(), name: 'Tiramisu', translationKey: 'tiramisu', category: 'Desserts', price: 11, available: true, description: 'Traditional Italian tiramisu', descriptionKey: 'tiramisuDesc' },
    { id: uuidv4(), name: 'Cheesecake', translationKey: 'cheesecake', category: 'Desserts', price: 10, available: true, description: 'New York style with berry compote', descriptionKey: 'cheesecakeDesc' },

    // Beverages
    { id: uuidv4(), name: 'Espresso', translationKey: 'espresso', category: 'Beverages', price: 4, available: true },
    { id: uuidv4(), name: 'Cappuccino', translationKey: 'cappuccino', category: 'Beverages', price: 6, available: true },
    { id: uuidv4(), name: 'Latte', translationKey: 'latte', category: 'Beverages', price: 7, available: true },
    { id: uuidv4(), name: 'Fresh Orange Juice', translationKey: 'freshOrangeJuice', category: 'Beverages', price: 8, available: true },
    { id: uuidv4(), name: 'Sparkling Water', translationKey: 'sparklingWater', category: 'Beverages', price: 5, available: true },
    { id: uuidv4(), name: 'Coca Cola', translationKey: 'cocaCola', category: 'Beverages', price: 5, available: true },
    { id: uuidv4(), name: 'House Wine (Glass)', translationKey: 'houseWineGlass', category: 'Beverages', price: 12, available: true },
    { id: uuidv4(), name: 'Premium Wine (Glass)', translationKey: 'premiumWineGlass', category: 'Beverages', price: 18, available: true },
    { id: uuidv4(), name: 'Beer (Draft)', translationKey: 'beerDraft', category: 'Beverages', price: 8, available: true },
    { id: uuidv4(), name: 'Cocktail', translationKey: 'cocktail', category: 'Beverages', price: 14, available: true }
  ];

  const tables: Table[] = [];
  
  for (let i = 1; i <= 20; i++) {
    const tableId = uuidv4();
    const seats = i <= 8 ? 2 : i <= 14 ? 4 : 6;
    
    let status: Table['status'] = 'free';
    const orders: Order[] = [];
    
    // Randomly assign some tables with orders
    const random = Math.random();
    
    if (random > 0.7) {
      // Table with order ready for payment (30% of tables)
      status = 'waiting-payment';
      const order: Order = {
        id: uuidv4(),
        tableId,
        items: [],
        status: 'pending',
        createdAt: new Date(Date.now() - Math.random() * 3600000), // Random time in last hour
        notes: Math.random() > 0.7 ? 'Birthday celebration' : '',
        total: 0
      };
      
      // Add random items to order (full meal)
      const itemCount = Math.floor(Math.random() * 4) + 3; // 3-6 items
      for (let j = 0; j < itemCount; j++) {
        const menuItem = menuItems[Math.floor(Math.random() * menuItems.length)];
        const quantity = Math.floor(Math.random() * 2) + 1;
        const orderItem: OrderItem = {
          id: uuidv4(),
          menuItemId: menuItem.id,
          name: menuItem.name,
          translationKey: menuItem.translationKey,
          quantity,
          price: menuItem.price,
          notes: Math.random() > 0.8 ? 'No onions' : undefined
        };
        order.items.push(orderItem);
      }
      
      order.total = order.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
      orders.push(order);
      
    } else if (random > 0.4) {
      // Table with order being prepared (30% of tables)
      status = 'awaiting-order';
      const order: Order = {
        id: uuidv4(),
        tableId,
        items: [],
        status: 'pending',
        createdAt: new Date(Date.now() - Math.random() * 1800000), // Random time in last 30 mins
        notes: '',
        total: 0
      };
      
      // Add some items (partial order - maybe just drinks/starters)
      const itemCount = Math.floor(Math.random() * 3) + 1; // 1-3 items
      
      // Prioritize beverages and starters for "awaiting" tables
      const startersAndDrinks = menuItems.filter(item => 
        item.category === 'Beverages' || item.category === 'Starters'
      );
      
      for (let j = 0; j < itemCount; j++) {
        const menuItem = startersAndDrinks[Math.floor(Math.random() * startersAndDrinks.length)];
        const quantity = menuItem.category === 'Beverages' ? Math.floor(Math.random() * 3) + 1 : 1;
        const orderItem: OrderItem = {
          id: uuidv4(),
          menuItemId: menuItem.id,
          name: menuItem.name,
          translationKey: menuItem.translationKey,
          quantity,
          price: menuItem.price
        };
        order.items.push(orderItem);
      }
      
      order.total = order.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
      orders.push(order);
      
    } else {
      // Table is free (40% of tables)
      status = 'free';
      // No orders for free tables
    }
    
    // Add some notes to random tables
    let notes = '';
    if (Math.random() > 0.8) {
      const sampleNotes = [
        'Regular customer',
        'Allergic to nuts',
        'Celebrating anniversary',
        'VIP guest',
        'Window seat preferred'
      ];
      notes = sampleNotes[Math.floor(Math.random() * sampleNotes.length)];
    }
    
    // Add reservations to some free tables
    let reservation = undefined;
    if (status === 'free' && Math.random() > 0.5) {
      const currentHour = new Date().getHours();
      const reservationHour = currentHour + Math.floor(Math.random() * 4) + 1; // 1-4 hours from now
      const minutes = Math.random() > 0.5 ? '00' : '30';
      const hour = reservationHour % 24;
      
      const names = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis'];
      reservation = {
        time: `${hour.toString().padStart(2, '0')}:${minutes}`,
        name: names[Math.floor(Math.random() * names.length)],
        partySize: Math.floor(Math.random() * seats) + 1
      };
    }
    
    tables.push({
      id: tableId,
      number: i,
      seats,
      status,
      orders,
      notes,
      reservation
    });
  }
  
  return { tables, menuItems };
}